import { createApp } from 'vue'
import App from './App.vue'
import './assets/reset.css'
// import preview from 'vue-phone-preview'

import 'element-plus/dist/index.css'
// import ElementPlus from 'element-plus'
import { ElButton, ElTable, ElInput, ElTabs, ElIcon, ElTabPane, ElCheckbox, ElRow, ElCol, ElMenu, ElSubMenu, ElMenuItemGroup, ElMenuItem, ElBadge, ElAvatar, ElPopover, ElDialog, ElTableColumn, ElPagination, ElAutocomplete, ElDatePicker, ElConfigProvider, ElRadioButton, ElRadioGroup, ElDrawer, ElOption, ElSelect, ElRate, ElStep, ElSteps, ElCard, ElMessage, ElSwitch, ElDivider, ElUpload, ElTree, ElDropdown,ElDropdownMenu,ElDropdownItem,ElTooltip} from 'element-plus'
// import { ElMessage } from 'element-plus'
import * as ElIconModules from '@element-plus/icons-vue'

import store from './store/index'
import router from './router/index'
import './permission'



// import {ElementTiptapPlugin} from 'element-tiptap'
// import 'element-tiptap/lib/index.css';

const components = [ElButton, ElTable, ElInput, ElTabs, ElIcon, ElTabPane, ElCheckbox, ElRow, ElCol, ElMenu, ElSubMenu, ElMenuItemGroup, ElMenuItem, ElBadge, ElAvatar, ElPopover, ElDialog, ElTableColumn, ElPagination, ElAutocomplete, ElDatePicker, ElConfigProvider, ElRadioButton, ElRadioGroup, ElDrawer, ElOption, ElSelect, ElRate, ElStep, ElSteps, ElCard, ElSwitch, ElDivider, ElUpload, ElTree,ElDropdown,ElDropdownMenu,ElDropdownItem,ElTooltip]
const app = createApp(App)

app.use(router)
app.use(store)
    // app.use(ElementPlus)

for (const component of components) {
    app.component(component.name, component)
}

app.config.globalProperties.$message = ElMessage;
// app.config.globalProperties.$confirm = ElMessageBox;

// app.use(QRCode)
// app.use(preview)
// app.use(router)
// app.use(ElementTiptapPlugin, {
//   lang: 'zh', // 设置语言为中文
// });

Object.keys(ElIconModules).forEach(function(key) {
    app.component(ElIconModules[key].name, ElIconModules[key])
})

app.mount('#app')